export default "__VITE_ASSET__BcL5UoeJ__"